export default __webpack_public_path__ + "static/media/Manifesto.6034dc73ce8acb360570e97dcc700f40.webp";